import { render, staticRenderFns } from "./ItemExpenses.vue?vue&type=template&id=463a7f30&"
import script from "./ItemExpenses.vue?vue&type=script&lang=js&"
export * from "./ItemExpenses.vue?vue&type=script&lang=js&"
import style0 from "./ItemExpenses.vue?vue&type=style&index=0&id=463a7f30&prod&lang=scss&"
import style1 from "./ItemExpenses.vue?vue&type=style&index=1&id=463a7f30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports